<template>
  <div class="idtr-sheet">
    <div class="idtr-hf idtr-hf--date">
      <field-input
        v-if="editable"
        v-model="idtrForm.header.printedAt"
        name="Printed at"
        :rules="{ required: true, regex: printedAtRegex }"
        placeholder="9/15/26, 3:48 PM"
        date-format="M/D/YY, h:mm A"
      />
      <template v-else>{{ idtrForm.header.printedAt }}</template>
    </div>
    <div class="idtr-hf idtr-hf--title">{{ title }}</div>
    <div class="idtr-hf idtr-hf--url">{{ url }}</div>
    <div class="idtr-hf idtr-hf--page">{{ page }}/{{ total }}</div>
    <div class="idtr-content"><slot></slot></div>
  </div>
</template>

<script>
import FieldInput from "./FieldInput.vue";
import {IDTR_URL} from "@/assets/constants/identity.theft.report.constants";

export default {
  components: {FieldInput},
  inject: ["idtrForm"],
  props: {
    page: {type: Number, required: true},
    total: {type: Number, required: true},
    title: {type: String, default: ""},
    editable: {type: Boolean, default: false},
  },
  data() {
    return {
      printedAtRegex: /^\d{1,2}\/\d{1,2}\/\d{2}, \d{1,2}:\d{2} (AM|PM)$/,
      url: IDTR_URL,
    };
  },
};
</script>
